import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import type { RecipientResponse } from '@shared/api';
import { Icon, Text } from '@shared/widgets';
import ChevronIcon from '@assets/icons/chevron.svg';

interface RecipientDetailsProps {
  className?: string;
  recipient: RecipientResponse;
}

export const RecipientDetails = (props: RecipientDetailsProps) => {
  const [showDetails, setShowDetails] = useState<boolean>(true);

  const { t } = useTranslation('payments');

  const details = useMemo(
    () =>
      [
        { label: t('recipient.details.fields.iban'), value: props.recipient.iban },
        { label: t('recipient.details.fields.bankName'), value: props.recipient.bankName },
        { label: t('recipient.details.fields.bicSwiftCode'), value: props.recipient.bic },
        { label: t('recipient.details.fields.firstName'), value: props.recipient.firstName },
        { label: t('recipient.details.fields.lastName'), value: props.recipient.lastName },
        { label: t('recipient.details.fields.companyName'), value: props.recipient.companyName },
      ].filter((item) => item.value),
    [t, props.recipient],
  );
  return (
    <div className={cn('flex w-full flex-col', props.className)}>
      <div className='flex cursor-pointer gap-2' onClick={() => setShowDetails((prev) => !prev)}>
        <Text>{t('recipient.details.title')}</Text>
        <Icon className={cn('-rotate-90 transition-transform duration-200', showDetails && 'rotate-90')} icon={<ChevronIcon />} />
      </div>
      {showDetails && (
        <ul className={cn('mt-3 flex flex-wrap gap-10')}>
          {details.map((item, idx) => (
            <li key={idx}>
              <Text size='sm' color='secondary'>
                {item.label}
              </Text>
              <Text weight='semibold' size='sm'>
                {item.value}
              </Text>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
